import type { QuoteRow } from "@/lib/quote-cache";
import { request } from "./transport";

export interface ListQuotesParams {
  tickers: string[];
  summary?: boolean;
  history?: boolean;
  from?: string;
  to?: string;
  resolution?: number;
}

// Read-only client. The browser never ingests — Sidekiq cron is the
// only writer. /api/v1/quotes/ingest exists server-side for internal
// callers but is not exposed here.
export const quotes = {
  listQuotes: ({
    tickers,
    summary,
    from,
    to,
    resolution,
  }: ListQuotesParams) => {
    const params = new URLSearchParams({ tickers: tickers.join(",") });
    if (summary) params.set("summary", "1");
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    if (resolution) params.set("resolution", String(resolution));
    return request<QuoteRow[]>(`/quotes?${params.toString()}`);
  },
};
